import CryptoJS from 'crypto-js';

import { createSlice } from '@reduxjs/toolkit';

// const isOnRedirectPage = window.location.pathname.startsWith('/redirect'); //suggested
const user = localStorage.getItem('user');
const defaultValue = !!user ? JSON.parse(CryptoJS.AES.decrypt(user, process.env.REACT_APP_SECRET_KEY).toString(CryptoJS.enc.Utf8)) : null;

//suggested
// const defaultValue = isOnRedirectPage
//   ? null
//   : !!localStorage.getItem('user')
//     ? JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('user'), process.env.REACT_APP_SECRET_KEY).toString(CryptoJS.enc.Utf8))
//     : null;

export const userSlice = createSlice({
  name: 'user',
  initialState: defaultValue,
  reducers: {
    setUserDetails: (_, action) => {
      return action.payload;
    },
    clearUserDetails: () => {
      return null;
    },
  },
});

export const { setUserDetails, clearUserDetails } = userSlice.actions;

export default userSlice.reducer;
